import { render, staticRenderFns } from "./WidgetsRender.vue?vue&type=template&id=65fe915e&"
import script from "./WidgetsRender.vue?vue&type=script&lang=js&"
export * from "./WidgetsRender.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsRender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCombobox,VSlider,VSubheader})
